import React, { useState } from 'react';
import { SelectBox } from 'devextreme-react';

const thresholdValues = [
    {"name":"°F (Fahrenheit)", "id": 100},
    {"name":"°C (Celcius)", "id": 2000}
];

function DropDownTemperature({ selectedThresholdValue }) {
    // Internal state to manage the dropdown value
    const [internalValue, setInternalValue] = useState(selectedThresholdValue);

    return (
        <>
            <div className={'utilizationdateBtnDropdown'} style={{ marginRight: '10px' }}>
            	<SelectBox 
            		value={internalValue}
            		placeholder="Select temperature"
            		focusStateEnabled={false}
            		width='210px'
            		labelMode="static"
                    label="Temperature Unit"
                    stylingMode="outlined"
            		height={40}
            		items={thresholdValues}
            		valueExpr="id"
            		displayExpr="name"
            		onValueChanged={(e) => setInternalValue(e.value)} // Update internal state
            	/>
            </div>
        </>
  );
}

export default DropDownTemperature;